import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { authFetchJson } from "./auth-fetch";
import { useAuthStore } from "./auth";

export type NotificationPrefs = {
  emailNewBooking?: boolean;
  emailPaymentReceipt?: boolean;
  emailWeeklyDigest?: boolean;
  emailSecurityAlerts?: boolean;
  inAppNewBooking?: boolean;
  inAppPaymentReceipt?: boolean;
};

export const NOTIFICATION_PREF_DEFAULTS: Required<NotificationPrefs> = {
  emailNewBooking: true,
  emailPaymentReceipt: true,
  emailWeeklyDigest: false,
  emailSecurityAlerts: true,
  inAppNewBooking: true,
  inAppPaymentReceipt: true,
};

export function useNotificationPrefs() {
  const accessToken = useAuthStore((s) => s.accessToken);
  return useQuery({
    queryKey: ["auth", "me", "notification-prefs"],
    enabled: !!accessToken,
    queryFn: () => authFetchJson<NotificationPrefs>(`/api/v1/auth/me/notification-prefs`),
  });
}

export function useUpdateNotificationPrefs() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Partial<NotificationPrefs>) =>
      authFetchJson<NotificationPrefs>(`/api/v1/auth/me/notification-prefs`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ["auth", "me", "notification-prefs"] }),
  });
}
